import React, { useState, useEffect } from 'react';
import { supabase } from '../lib/supabaseClient';

const BASE = [
  { location: 'Kandhal', pastor: 'Jeyakumar', address: null, phone: null, maps_url: 'https://maps.google.com/?q=Kandhal+Ooty+Tamil+Nadu' },
  { location: 'Coonoor', pastor: 'Stephen', address: null, phone: null, maps_url: 'https://maps.google.com/?q=Coonoor+Tamil+Nadu' },
  { location: 'Kodanadu, Kothagiri', pastor: 'Sathrak', address: null, phone: null, maps_url: 'https://maps.google.com/?q=Kodanadu+Kothagiri+Tamil+Nadu' },
];

export default function Branches() {
  const [branches, setBranches] = useState(BASE);

  useEffect(() => {
    let cancelled = false;
    supabase.from('branches').select('*').order('display_order', { ascending: true })
      .then(({ data }) => {
        if (!cancelled && data && data.length > 0) setBranches(data);
      }).catch(() => {});
    return () => { cancelled = true; };
  }, []);

  return (
    <section id="branches" className="section" style={{ background: 'var(--bg-deep)' }}>
      <div className="container">
        <div style={{ textAlign: 'center' }}>
          <span className="section-tag">✦ Growing His Kingdom</span>
          <h2 className="section-title">Branch <span>Churches</span></h2>
          <div className="divider center" />
          <p style={{ fontFamily: "'Crimson Pro',serif", fontSize: '1.05rem', color: 'var(--text-muted)', maxWidth: 560, margin: '0 auto 44px', lineHeight: 1.7 }}>
            God's work is expanding! Zion Assemblies of God is blessed with thriving branch congregations across the Nilgiris.
          </p>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(270px,1fr))', gap: 22 }}>
          {branches.map((b, i) => (
            <div key={i} className="card fade-up" style={{ padding: '34px 26px', textAlign: 'center' }}>
              <div style={{ fontSize: '2.5rem', marginBottom: 18 }}>⛪</div>
              <div style={{ fontFamily: "'Cinzel Decorative',serif", fontSize: '1rem', color: 'var(--primary)', marginBottom: 10 }}>{b.location}</div>
              <div style={{ fontSize: '0.74rem', color: 'var(--text-muted)', letterSpacing: '0.08em', marginBottom: 14 }}>Zion Assemblies of God Church</div>
              {b.address && <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)', marginBottom: 8 }}>📍 {b.address}</div>}
              {b.phone && <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)', marginBottom: 12 }}>📞 {b.phone}</div>}
              <div style={{ display: 'inline-block', background: 'rgba(201,168,76,0.1)', border: '1px solid rgba(201,168,76,0.3)', borderRadius: 40, padding: '7px 18px', fontSize: '0.82rem', color: 'var(--primary-light)', marginBottom: 14 }}>
                Pastor {b.pastor}
              </div>
              <br/>
              {/* Google Maps link */}
              <a
                href={b.maps_url || `https://maps.google.com/?q=Zion+Assemblies+of+God+${encodeURIComponent(b.location)}+Tamil+Nadu`}
                target="_blank"
                rel="noreferrer"
                style={{
                  display: 'inline-flex', alignItems: 'center', gap: 6,
                  background: 'rgba(66,133,244,0.12)', border: '1px solid rgba(66,133,244,0.35)',
                  borderRadius: 40, padding: '7px 16px',
                  fontSize: '0.76rem', color: '#6ab4ff', textDecoration: 'none',
                  transition: 'all 0.2s', marginTop: 4,
                }}
                onMouseEnter={e => { e.currentTarget.style.background='rgba(66,133,244,0.25)'; }}
                onMouseLeave={e => { e.currentTarget.style.background='rgba(66,133,244,0.12)'; }}
              >
                📍 Click for Location
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
